export const he = {
  auth: {
    logout: "התנתקות",
    language: "Language",
    login: "מעבר למסך ההתחברות",
    logoutTitle: "תוקף החיבור שלך חלף.",
    logoutDescription: "תועבר למסך ההתחברות באופן אוטומטי תוך 5 שניות או שתוכל ללחוץ על הכפתור כדי לעבור מיידית.",
    account: "Account Settings"
  },
  layout: {
    chooseSystem: "בחר מערכת",
    sure: "האם אתה בטוח?",
    search: "חיפוש",
    system: "מערכת",
    stock: "מלאי",
    activate: "הפעל",
    confirm: "אשר",
    cancel: "בטל",
    submit: "שלח",
    home: "בית",
    control: "שליטה",
    orders: "הזמנות",
    metadata: "רישומי מטא נתונים",
    monitoring: "ניטור",
    replenishment: "חידוש מלאי",
    transfers: "נתוני העברות",
    keys: "מפתחות",
    indexing: "בקשות אינדוקס",
    streams: "שידורים חיים",
    library: "ספריה",
    store: "חנות",
    support: "תמיכה",
    warranty: "אחריות",
    "products-portfolio": "פורטפוליו מוצרים",
    orderDetail: "פרטי הזמנה",
    tableRows: "שורות בעמוד",
    portfolio: "פורטפוליו מוצרים",
    uploadTitle: "Upload image",
    uploadRule: "Max file size: {{size}}MB",
    uploadTip: "Browse",
    pleaseWait: "Please wait",
    fileSizeError: "Image size exceeds {{size}} MB. Please select a smaller image.",
    users: "Users",
    profile: "Account"
  },
  navigation: {
    home: "בית",
    orders: "הזמנות",
    stock: "מלאי",
    store: "חנות",
    productsPortfolio: "פורטפוליו מוצרים",
    metadata: "מטא נתונים",
    users: "Users Management",
    account: "Account",
    profile: "My profile",
    back: "Back",
    logout: "Logout"
  },
  systems: {
    estop: "RStop",
    hours: "שעות",
    days: "ימים",
    title: "מערכת",
    lastUpdated: "עודכן לאחרונה: לפני {{time}}",
    open: "פתוח",
    closed: "סגור",
    confirmation: "האם אתה בטוח?",
    active: "פעיל",
    inactive: "מושבת",
    ago: "לפני",
    summary: "סיכום",
    pallets: "משטחים",
    emptyPallets: "משטחים ריקים",
    temperature: "טמפרטורה",
    packerStock: "מלאי אורזים",
    monitor: "ניטור",
    keys: "מפתחות",
    yes: "כן",
    unavailable: "לא זמין כרגע",
    buffers: "מאגרי זיכרון",
    mode: "מצב מערכת",
    pickup: "איסוף",
    activity: "פעילות",
    containerState: "מצב מכולה",
    activeTasksTitle: "משימות מערכת מופעלות",
    activeTasksDescription: "משימות שהמערכת מבצעת",
    maintenance: "תחזוקה",
    collection: "איסוף חבילות",
    newOrdersTitle: "קבלת הזמנות חדשות",
    newOrdersDescription: "המערכת מקבלת הזמנות חדשות מלקוחות מרוחקים",
    availability: "זמינות",
    orders: "הזמנות",
    reservations: "הזמנות מראש",
    validations: "אישורים",
    machineSpeed: "מהירות מכונה",
    Low: "נמוכה",
    Medium: "בינונית",
    Fast: "מהירה",
    compressor: "מדחס",
    on: "מופעל",
    off: "כבוי",
    notAvailable: "לא זמין",
    stateError: "System state is currently unavailable"
  },
  stock: {
    title: "מלאי",
    pallet: "משטח",
    loadedAt: "נטען ב",
    markForMaintenance: "סמן לתחזוקה",
    totalProducts: "סה\"כ מוצרים",
    name: "שם",
    sku: "מזהה מוצר (SKU)",
    quantity: "כמות",
    shop: "חנות",
    cart: "עגלת קניות",
    clear: "נקה הכל",
    empty: "העגלה ריקה",
    total: "סה\"כ",
    order: "הזמן עכשיו",
    orderFail: "יצירת ההזמנה נכשלה",
    orderSuccessTitle: "יששש!",
    orderSuccessDescription: "הזמנה מספר {{id}} נוצרה בהצלחה",
    searchPlaceholder: "חפש מוצרים לפי שם"
  },
  orders: {
    id: "מזהה",
    time: "תאריך ושעה",
    source: "מקור",
    packs: "מספר חבילות",
    status: "סטטוס הזמנה",
    displayCode: "קוד תצוגה",
    priority: "עדיפות",
    delivery: "משלוח",
    total: "סה\"כ הזמנות",
    selectStatuses: "בחר סטטוסים",
    searchPlaceholder: "חפש לפי פרטים",
    idPlaceholder: "חפש לפי מזהה",
    searchHint: "הקלד לפחות 2 תווים",
    statusPlaceholder: "בחר סטטוסים",
    resetFilters: "אפס מסננים",
    table: "טבלה",
    board: "לוח",
    noOrders: "אין הזמנות להצגה",
    export: "ייצא ל-CSV",
    parts: "חלקים",
    api: "API",
    user: "משתמש",
    processMany: "הכנס את ההזמנות המסומנות לתור",
    selectedOrder: "הזמנה 1 נבחרה",
    selectedOrders: "{{amount}} הזמנות נבחרו",
    processSuccess: "ההזמנות נכנסו לתור בהצלחה",
    processPartiallySuccess: "הפעולה הצליחה חלקית, אנא נסה שנית",
    processError: "הפעולה נכשלה",
    search: "Search",
    clear: "Clear"
  },
  order: {
    details: "פרטי הזמנה",
    id: "מזהה הזמנה",
    packs: "חבילות",
    code: "קוד תצוגה",
    pinCode: "קוד פינה",
    phone: "מספר טלפון",
    timeline: "זמן",
    name: "שם",
    address: "כתובת",
    locale: "שפה",
    datetime: "תאריך ושעה",
    priority: "עדיפות",
    productName: "שם מוצר",
    productDescription: "תיאור מוצר",
    productType: "סוג מוצר",
    productPickingType: "סוג איסוף",
    sku: "מזהה מוצר",
    quantity: "כמות",
    collectedQuantity: "כמות שנאספה",
    returnedQuantity: "כמות שהוחזרה",
    refundQuantity: "כמות להחזר כספי",
    totalProducts: "סה\"כ מוצרים",
    payment: "תשלום",
    pending: "ממתין",
    queued: "ממתין",
    fetched: "נאסף",
    collecting: "נאסף",
    collected: "נאסף",
    ready: "מוכן",
    delivering: "משלוח",
    delivered: "משלוח",
    error: "שגיאה",
    cancelled: "בוטל",
    "payment-queued-label": "דלג על תשלום",
    "pending-queued-label": "הכנס לתור",
    "ready-delivering-label": "משלוח",
    "error-pending-label": "נסה שנית",
    "error-queued-label": "נסה שנית",
    "process-refunds": "בצע זיכוי כספי עכשיו",
    "cancelled-label": "בטל",
    identifier: "מזהי מוצר",
    manuallyChangeReturnedQuantity: "שנה ידנית את הכמות שהוחזרה",
    changeReturnedQuantity: "שנה את הכמות שהוחזרה",
    returnedQuantityWarning: "הכמות המוחזרת לא יכולה לעלות על הכמות שנאספה",
    update: "ערוך",
    successQuantityMessage: "הכמות שהוחזרה עודכנה בהצלחה",
    errorQuantityMessage: "אירעה שגיאה בעת עדכון הכמות שהוחזרה",
    processRefundsSuccess: "הזיכויים עובדו בהצלחה",
    processRefundsError: "אירעה שגיאה בעת עיבוד הזיכויים",
  },
  system: {
    searchPlaceholder: "חפש במוצרים",
    name: "שם",
    identifier: "מזהי מוצר",
    sku: "מזהה מוצר (SKU)",
    totalQuantity: "סה\"כ",
    assignedQuantity: "מוקצה",
    reservedQuantity: "מורכב",
    availableQuantity: "זמין",
    total: "סה\"כ מוצרים",
    healthy: "תקין",
    online: "מופעל",
    paused: "מושבת",
    estop: "E-Stop",  
  },
  productsPortfolio: {
    products: "מוצרים",
    name: "שם",
    brand: "מותג",
    type: "סוג",
    pickingType: "סוג איסוף",
    nutrition: "מידע תזונתי",
    price: "מחיר",
    defaultPrice: "מחיר ברירת מחדל",
    priceSublines: "פירוט מחיר",
    imageSize: "גודל תמונה",
    category: "קטגוריה",
    label: "תוויה",
    categoryName: "שם קטגוריה",
    labelName: "שם תוויה",
    sku: "מזהה מוצר (SKU)",
    disabledSystems: "מערכות מושבתות",
    searchPlaceholder: "חפש במוצרים",
    categoriesPlaceholder: "כל הקטגוריות",
    labelsPlaceholder: "כל התוויות",
    disabledSystemsFilter: "רק מוצרים עם מערכות מושבתות",
    resetFilters: "אפס מסננים",
    productName: "שם מוצר",
    productImage: "שם מוצר",
    temperature: "טמפרטורה",
    frozen: "קפוא",
    fresh: "Fresh",
    chilled: "מצונן",
    cold: "קר",
    ambient: "לא מקורר",
    none: "ללא",
    external: "חיצוני",
    properties: "מאפיינים",
    regular: "רגיל",
    bundle: "קבוצה",
    automated: "אוטומטי",
    manual: "ידני",
    integrated: "מוטמע",
    weight: "משקל",
    size: "גודל",
    small: "קטן",
    medium: "בינוני",
    big: "גדול",
    create: "צור",
    namePlaceholder: "הזן שם מוצר",
    descriptionPlaceholder: "הזן תיאור מוצר",
    brandPlaceholder: "הזן שם מותג",
    nutritionPlaceholder: "הזן מידע תזונתי",
    pricePlaceholder: "הזן מחיר",
    heightMm: "גובה (מ\"מ)",
    heightMmPlaceholder: "הזן גובה במילימטרים",
    widthMm: "רוחב (מ\"מ)",
    widthMmPlaceholder: "הזן רוחב במילימטרים",
    lengthMm: "אורך (מ\"מ)",
    lengthMmPlaceholder: "הזן אורך במילימטרים",
    weightKg: "משקל (ק\"ג)",
    weightKgPlaceholder: "הזן משקל בקילוגרמים",
    volumeL: "נפח (ליטר)",
    volumeLPlaceholder: "הזן נפח בליטרים",
    categoryNamePlaceholder: "הזן שם קטגוריה",
    labelNamePlaceholder: "הזן שם תוויה",
    imageSizePlaceholder: "הזן גודל תמונה",
    dropdownPlaceholder: "נא לבחור",
    createTitle: "צור מוצר חדש",
    createProductButton: "מוצר חדש",
    requiredMessage: "שדה זה הינו חובה",
    createProductSuccess: "המוצר נוצר בהצלחה",
    createProductFail: "שגיאה ביצירת המוצר",
    updateProductSuccess: "המוצר עודכן בהצלחה",
    updateProductFail: "שגיאה בעדכון המוצר",
    archiveProductSuccess: "Product archived successfully",
    archiveProductFail: "Error while archiving product",
    unarchiveProductSuccess: "Product unarchived successfully",
    unarchiveProductFail: "Error while unarchiving product",
    optional: "(אופציונלי)",
    nameSuccess: "שם המוצר עודכן בהצלחה",
    nameError: "שגיאה בעדכון שם המוצר",
    categorySuccess: "קטגוריית המוצר עודכנה בהצלחה",
    categoryError: "שגיאה בעדכון קטגוריית המוצר",
    createCategoryError: "שגיאה ביצירת קטגוריית מוצר",
    noCategory: "ללא קטגוריה",
    skusTitle: "מזהי מוצר (SKU) של המוצר",
    addSku: "הוסף מזהה מוצר (SKU)",
    createCategory: "צור קטגוריה חדשה",
    createLabel: "צור תוויה חדשה",
    skuNamePlaceholder: "הזן שם מזהה מוצר (SKU)",
    barCodes: "ברקודים",
    barCodesPlaceholder: "הזן ברקודים",
    barCodesAddPlaceholder: "הזן ברקוד להוספה",
    barCodesTip: "הפרד מספר ברקודים באמצעות פסיק",
    cancel: "בטל",
    save: "שמור",
    addSkuSuccess: "מזהה מוצר (SKU) נוסף בהצלחה למוצר",
    addSkuError: "שגיאה בהוספת מזהה מוצר (SKU) למוצר",
    addBarcodeSuccess: "ברקוד נוסף בהצלחה למזהה מוצר (SKU)",
    addBarcodeError: "שגיאה בהוספת ברקוד למזהה מוצר (SKU)",
    emptyBarcodeError: "הברקוד לא יכול להיות ריק",
    more: "עוד",
    status: "סטטוס",
    pending: "ממתין",
    approved: "מאושר",
    declined: "נדחה",
    archived: "Archived",
    approvePendingProducts: "אשר מוצרים ממתינים",
    details: "פרטים",
    productSkus: "מזהי מוצר (SKU) של המוצר",
    externalLabel: "אחסון חיצוני",
    enabled: "מופעל",
    saveChanges: "שמור שינויים",
    declineProduct: "דחה מוצר",
    revertProduct: "בטל מוצר",
    approveProduct: "אשר מוצר",
    archiveProduct: "ארכיון מוצר",
    unarchiveProduct: "ביטול ארכיון מוצר",
    statusesPlaceholder: "כל הסטטוסים",
    confirmation: "האם אתה בטוח?",
    export: "ייצא ל-CSV",
    identifiers: "מזהי מוצר",
    prices: "מחירים",
    value: "ערך",
    addIdentifier: "הוסף מזהה",
    updatePrice: "עדכן מחיר",
    selectIdentifierType: "בחר סוג מזהה",
    enterIdentifierValue: "הזן ערך מזהה",
    addNewIdentifier: "הוסף מזהה חדש",
    defaultPrice: "מחיר דיפולטיבי",
    enterPriceValue: "הכנס ערך כספי",
    addNewSubline: "הוסף תכונה למחיר",
    priceAmount: "ערך מספרי",
    priceDescription: "שם תכונה",
    modifiers: "משנים",
    key: "מפתח",
    values: "ערכים",
    valueName: "שם הערך",
    addModifier: "הוסף משנה",
    enterModifierKey: "הזן מפתח משנה",
    enterModifierName: "הזן שם משנה",
    enterModifierValue: "הזן ערך משנה",
    enterModifierValueName: "הזן שם ערך משנה",
    addNewModifier: "הוסף משנה חדש",
    modifierValues: "ערכי משנה",
    addValue: "הוסף ערך",
    priceChangeSuccess: "המחירים עודכנו בהצלחה",
    priceChangeError: "אירעה שגיאה בעת עדכון המחירים",
    deleteProduct: "מחק מוצר",
    deleteProductConfirmation: "האם אתה בטוח שברצונך למחוק מוצר זה?",
    deleteProductSuccess: "המוצר נמחק בהצלחה",
    deleteProductFail: "אירעה שגיאה בעת מחיקת המוצר",
  },
  store: {
    identifier: "מזהי מוצר",
    searchPlaceholder: "חפש במוצרים",
    cart: "עגלת קניות",
    resetFilters: "אפס מסננים",
    name: "שם",
    totalQuantity: "סה\"כ כמות",
    availableQuantity: "זמין",
    assignedQuantity: "מוקצה",
    reservedQuantity: "שמור",
    sku: "מזהה מוצר (SKU)",
    id: "מזהה",
    quantity: "כמות",
    add: "הוסף לעגלה",
    total: "סה\"כ מוצרים",
    clear: "נקה הכל",
    create: "צור הזמנה",
    placeOrderSuccess: "ההזמנה נוצרה בהצלחה",
    placeOrderError: "שגיאה ביצירת ההזמנה"
  },
  support: {
    support: "תמיכה",
    pageTip: "נא לספק את המידע בנוגע למקרה שלך למטה, וצוות התמיכה שלנו יסייע לך בהקדם האפשרי.",
    subject: "נושא",
    subjectPlaceholder: "הזן את נושא המקרה שלך",
    description: "תיאור",
    descriptionPlaceholder: "תאר פרטים",
    submit: "שלח",
    successTitle: "המקרה נשלח בהצלחה!",
    successDescription: "צוות התמיכה יסייע לך בהקדם האפשרי. לקבלת סיוע נוסף, תוכל למצוא את פרטי הכרטיס בדוא\"ל שלך.",
    close: "סגור",
    modalDescription: "נא לספק את המידע בנוגע למקרה שלך למטה.",
    cancel: "בטל"
  },
  metadata: {
    filterName: "חפש לפי שם",
    filterRequired: "הצג רק חובה",
    filterClear: "נקה מסנן",
    entries: "רישומים",
    name: "שם",
    options: "אפשרויות",
    type: "סוג",
    required: "חובה",
    edit: "ערוך",
    delete: "מחק",
    Int: "מספר שלם",
    Bool: "בוליאני",
    String: "מחרוזת",
    Float: "מספר עשרוני",
    addNew: "הוסף רישום חדש",
    namePlaceholder: "הזן שם",
    typePlaceholder: "הזן סוג",
    optionsPlaceholder: "הוסף אפשרויות, מופרדות בפסיק",
    requiredLabel: "סמן כחובה",
    cancel: "בטל",
    add: "הוסף רישום",
    editDrawerTitle: "ערוך מטא נתונים",
    save: "שמור שינויים",
    createSuccessMessage: "הרישום נוצר בהצלחה!",
    createErrorMessage: "שגיאה ביצירת הרישום!",
    updateSuccessMessage: "הרישום עודכן בהצלחה!",
    updateErrorMessage: "שגיאה בעדכון הרישום!",
    deleteSuccessMessage: "הרישום נמחק בהצלחה!",
    deleteErrorMessage: "שגיאה במחיקת הרישום!",
    confirmationTitle: "אשר מחיקה",
    deletionConfirmation: "האם אתה בטוח שברצונך למחוק את הרישום?",
    confirm: "אשר",
    requiredMessage: "שדה זה הינו חובה"
  },
  users: {
    selectTypes: "Select types",
    searchPlaceholder: "Search by Name or Email",
    searchHint: "Type at least 2 symbols",
    typePlaceholder: "Select types",
    resetFilters: "Reset Filters",
    users: "Users",
    permissions: "Permissions",
    name: "Name",
    email: "Email",
    userType: "User Type",
    add: "Add",
    User: "User",
    Admin: "Admin",
    SuperAdmin: "SuperAdmin",
    total: "Total",
    edit: "Edit",
    block: "Block",
    unblock: "Unblock",
    delete: "Delete",
    requiredMessage: "This field is required",
    emailValidationMessage: "Email is not valid",
    namePlaceholder: "Enter name",
    emailPlaceholder: "Enter email",
    type: "Assign type",
    pleaseSelect: "Please select",
    createSuccessMessage: "User successfully created!",
    createErrorMessage: "Error while creating user!",
    updateSuccessMessage: "User successfully updated!",
    updateErrorMessage: "Error while updating user!",
    addNew: "Add new user",
    deleteUserConfirmation: "Delete User",
    deleteUserConfirmationDescription: "Are you sure you want to remove the user from the system?",
    deleteUserSuccess: "User successfully deleted!",
    deleteUserError: "Error while deleting user!",
    addUser: "Add user",
    addRole: "Add role",
    assignUser: "Add user to specific permission",
    assignRole: "Add roles for the {{name}}",
    assignUserPlaceholder: "Search by name",
    assignRolePlaceholder: "Search role",
    cancel: "Cancel",
    assignSuccess: "Users successfully assigned to the role!",
    assignError: "Error while assigning users to the role!",
    assignRoleSuccess: "Roles successfully assigned to the user!",
    assignRoleError: "Error while assigning roles to the user!",
    revoke: "Revoke",
    revokeSuccess: "User successfully revoked from the role!",
    revokeError: "Error while revoking user from the role!",
  },
  settings: {
    compare: "Stock compare feature",
    shipping: "Shipping feature",
  },
  userRoles: {
    orderData: {
      title: "Order Data Access",
      description: "View all data related to orders.",
    },
    orderCreation: {
      title: "Order Creation",
      description: "Submit new orders via the Store page.",
    },
    orderManagement: {
      title: "Order Management",
      description: "Manage the full order lifecycle, including queueing, canceling, and manually collecting orders.",
    },
    replenishmentData: {
      title: "Replenishment Data Access",
      description: "View complete details of replenishment sessions and operations, including machine replenishment keys.",
    },
    indexingTaskControl: {
      title: "Indexing Task Control",
      description: "Create and manage system indexing tasks, with the option to cancel tasks.",
    },
    basicReplenishmentKeyCreation: {
      title: "Basic Replenishment Key Creation",
      description: "Create keys for inserting and extracting pallets.",
    },
    advancedReplenishmentKeyCreation: {
      title: "Advanced Replenishment Key Creation",
      description: "Create keys with additional privileges, including Safe and Jog modes.",
    },
    keyManagement: {
      title: "Key Management",
      description: "Deactivate or reactivate existing keys.",
    },
    productPortfolioAccess: {
      title: "Product Portfolio Access",
      description: "View product data along with metadata configuration.",
    },
    clientConfigurationManagement: {
      title: "Client Configuration Management",
      description: "Modify client configurations to control cloud services and machine operations.",
    },
    systemDataAccess: {
      title: "System Data Access",
      description: "View detailed system information, including status, structure, and stock levels.",
    },
    systemStateManagement: {
      title: "System State Management",
      description: "Control systems state settings, such as accepting new orders, pausing/unpausing, and activating/deactivating system tasks like Fulfillment and Replenishment.",
    },
    mediaDataAccess: {
      title: "Media Data Access",
      description: "View live camera feeds and stored video content.",
    },
    mediaAccess: {
      title: "Media Access",
      description: "View live camera feeds and stored video content.",
    },
    mediaCreation: {
      title: "Media Creation",
      description: "Submit new video requests.",
    },
    systemControlManagement: {
      title: "System Control Management",
      description: "Take control of the system and execute operations remotely.",
    },
    rStopControl: {
      title: "R-Stop Control",
      description: "Activate or deactivate the R-Stop remotely.",
    },
    productMetadataManagement: {
      title: "Product Metadata Management",
      description: "Add, update, or delete product metadata. Manage metadata types and requirements.",
    },
    productPortfolioManagement: {
      title: "Product Portfolio Management",
      description: "Create new products, categories, and SKUs. Update unapproved products with details such as name, image, category, and metadata.",
    },
    productPortfolioAdministration: {
      title: "Product Portfolio Administration",
      description: "Manage product permissions, including approving products and updating previously approved ones.",
    },  
  },
  home: {
    selectSystem: "Select a system"
  },
  profile: {
    profile: "Profile",
    name: "Name",
    email: "Email",
    permissions: "My Permissions",
  }
};